import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import InstaTagPosts from './InstaTagPosts'
import InstaAppPreview from './InstaAppPreview'

class InstaEditApp extends Component {

  render () {
    const { app, location } = this.props
    switch (location.sceneNum) {
      case 2: return <InstaTagPosts app={app} />
      case 3: return <InstaAppPreview app={app} />
      default:
        return <div>the page is not implemented yet</div>
    }
  }
}

InstaEditApp.propTypes = {
  app: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  location: state.location
})

export default connect(mapStateToProps)(InstaEditApp)



// WEBPACK FOOTER //
// ./src/components/editor/insta/InstaEditApp.js